module.exports = __webpack_public_path__ + "assets/icons_close-modal.540c341c.svg";